import { render, staticRenderFns } from "./pagingReading.vue?vue&type=template&id=711136ec&scoped=true"
import script from "./pagingReading.vue?vue&type=script&lang=js"
export * from "./pagingReading.vue?vue&type=script&lang=js"
import style0 from "./pagingReading.vue?vue&type=style&index=0&id=711136ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711136ec",
  null
  
)

export default component.exports